import React from "react";

export default ({
                    title = "",
                    d1 = "",
                    d2 = "",
                    d3 = "",
                    d4 = "",
                    d5 = "",
                    d6 = "",
                    d7 = "",
                    d8 = "",
                    d9 = "",

                }) => {
    return (
        <>
            <h1>{title}</h1>
            <p>
                {d1}
            </p>
            <p>
                {d2}
            </p>
            <p>
                {d3}
            </p>
            <p>
                {d4}
            </p>
            <p>
                {d5}
            </p>
            <p>
                {d6}
            </p>
            <p>
                {d7}
            </p>
            <p>
                {d8}
            </p>
            <p>
                {d9}
            </p>
        </>
    );
};
